import React from "react";

export default function IconFriends() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.07153C11.8769 7.07153 13.3984 5.55 13.3984 3.6731C13.3984 1.79619 11.8769 0.274658 10 0.274658C8.12309 0.274658 6.60156 1.79619 6.60156 3.6731C6.60156 5.55 8.12309 7.07153 10 7.07153Z"
        fill="#"
      />
      <path
        d="M16.875 7.0715C18.0615 7.0715 19.0234 6.10961 19.0234 4.92307C19.0234 3.73652 18.0615 2.77463 16.875 2.77463C15.6885 2.77463 14.7266 3.73652 14.7266 4.92307C14.7266 6.10961 15.6885 7.0715 16.875 7.0715Z"
        fill="#"
      />
      <path
        d="M3.125 7.0715C4.31155 7.0715 5.27344 6.10961 5.27344 4.92307C5.27344 3.73652 4.31155 2.77463 3.125 2.77463C1.93845 2.77463 0.976562 3.73652 0.976562 4.92307C0.976562 6.10961 1.93845 7.0715 3.125 7.0715Z"
        fill="#"
      />
      <path
        d="M5.2418 9.00082C4.39609 8.30793 3.6302 8.39965 2.65234 8.39965C1.18984 8.39965 0 9.58246 0 11.036V15.302C0 15.9332 0.515234 16.4465 1.14883 16.4465C3.88422 16.4465 3.55469 16.496 3.55469 16.3286C3.55469 13.3057 3.19664 11.0888 5.2418 9.00082Z"
        fill="#"
      />
      <path
        d="M10.9302 8.41523C9.22222 8.27277 7.73765 8.41687 6.45715 9.47383C4.31429 11.1902 4.72668 13.5013 4.72668 16.3285C4.72668 17.0765 5.33527 17.6965 6.09465 17.6965C14.34 17.6965 14.6682 17.9625 15.1571 16.8797C15.3175 16.5135 15.2736 16.6299 15.2736 13.127C15.2736 10.3447 12.8645 8.41523 10.9302 8.41523Z"
        fill="#"
      />
      <path
        d="M17.3478 8.39961C16.3646 8.39961 15.6029 8.30883 14.7583 9.00078C16.7882 11.0733 16.4454 13.1389 16.4454 16.3285C16.4454 16.497 16.1719 16.4465 18.8103 16.4465C19.4665 16.4465 20.0001 15.9148 20.0001 15.2613V11.0359C20.0001 9.58243 18.8103 8.39961 17.3478 8.39961Z"
        fill="#"
      />
    </svg>
  );
}
